import React, { useState, useRef, useEffect } from "react";
import ImageSkeleton from "./ImageSkeleton";

const LazyImage = ({
  src,
  alt,
  className = "",
  skeletonClassName = "",
  onLoad = () => {},
  onError = () => {},
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      },
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleLoad = () => {
    setIsLoaded(true);
    onLoad();
  };

  const handleError = () => {
    setHasError(true);
    onError();
  };

  return (
    <div ref={imgRef} className={`lazy-image-container ${className}`}>
      {!isLoaded && !hasError && (
        <ImageSkeleton className={`about-skeleton ${skeletonClassName}`} />
      )}

      {isInView && !hasError && (
        <img
          src={src}
          alt={alt}
          onLoad={handleLoad}
          onError={handleError}
          style={{
            display: isLoaded ? "block" : "none",
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          {...props}
        />
      )}

      {hasError && (
        <div className="image-error">
          <p>Failed to load image</p>
        </div>
      )}
    </div>
  );
};

export default LazyImage;
